import React from 'react'
import SvgIcon from './SvgIcon'

export default SvgIcon(
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.48 14.39"><title>SiteIcons</title><path d="M10.36,8.9A.83.83,0,0,0,11,8.63l6.5-7.24A.83.83,0,0,0,16.24.28L9.74,7.52a.83.83,0,0,0,.62,1.38Z"/><path d="M1.41,8.37A.83.83,0,0,0,.24,9.54l4.6,4.6A.83.83,0,0,0,6,13Z"/><path d="M22,.28,11.2,12.36l-4-4A.83.83,0,0,0,6,9.54l4.6,4.6a.83.83,0,0,0,.59.24h0a.83.83,0,0,0,.59-.27L23.27,1.38A.83.83,0,1,0,22,.28Z"/></svg>
)